/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-07-06 10:24:04
 */
import config from "@/configs/pathConfigures";
import LayoutEx from "@/views/layout/LayoutEx";

export default {
    path: config.prefixUrl,
    component: LayoutEx,
    props: {
        routeMapClass: "route-map__float",
    },
    meta: { title: "系统管理" },
    children: [
        {
            name: "productManager",
            path: "/product/info",
            component: () => import("@/views/systemManager/TenantProductInfo.vue"),
            meta: {title: "授权和套餐"}
        }
    ]
}